/* eslint-disable */
import Actuator from '@/models/Actuator';
import mathFormulaService from "@/services/math.formula.service";
import actuatorService from "@/services/actuator.gasPneumatic.service";
import asBasis from "@/services/as.basis.service";
import { buildAntriebDrehsObj } from "@/services/actuator.drehmoment-map.service";

let HUB_ARRAY: number[] = [];

// const khWinkelArray = [95, 90, 85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 30, 25, 20, 15, 10, 5, 0, -5];
let khWinkelArray: number[] = [];
for(let i = 95; i >= -5; i--) {
    khWinkelArray.push(i);
}

let maxSum: number = 0;
let torques: any = {};
let winkelKraftObject: any = {};

const logASLabelDecision = (payload: {
    phase: string;
    driveType: string;
    driveTypeA: string;
    controlType: string;
    antriebIndex: number;
    antriebValue: string;
    zylKey: number;
    federKEY: string;
    label: string;
    federOK?: boolean;
    isOverMaxAct?: boolean;
    cantedEndmomentLaufmomentOK?: boolean;
    torqueSnapshot?: any;
}) => {
    // if (process.env.NODE_ENV === 'production') return;

    // Helps understand why e.g. ASH-280S-350-DA was chosen:
    // 280 -> asBasis.ANTRIEBE_ARRAY[antriebIndex], S -> driveTypeA short, 350 -> zylKey.
    console.groupCollapsed(`[AS label decision] ${payload.label}`);
    console.log('phase', payload.phase);
    console.log('labelParts', {
        controlTypePrefix: `AS${payload.controlType}`,
        antriebFromBasisArray: payload.antriebValue,
        driveTypeAShort: (payload.driveTypeA === 'AS-S') ? 'S' : 'C',
        zylinderKey: payload.zylKey,
        driveTypeSuffix: payload.driveType,
        federKey: payload.federKEY || '(none for DA)'
    });
    console.log('candidateContext', {
        antriebIndex: payload.antriebIndex,
        federOK: payload.federOK,
        isOverMaxAct: payload.isOverMaxAct,
        cantedEndmomentLaufmomentOK: payload.cantedEndmomentLaufmomentOK
    });
    if (payload.torqueSnapshot) {
        console.log('torqueSnapshot', payload.torqueSnapshot);
    }
    console.groupEnd();
};

const getMasterAS = (data: Actuator): any => {

    actuatorService.setSecurityFactors(data.btoSecFac, data.runningSecFac, data.etoSecFac, data.btcSecFac, data.runningOutSecFac, data.etcSecFac);
    const securityFactors = actuatorService.getSecurityFactors();

    const actuatorAngles = {
        bto: data.btoAngle,
        btoRunning: data.runningAngle,   // was 'running' — must match setWinkelkraft parameter keys
        eto: data.etoAngle,
        btc: data.btcAngle,
        btcRunning: data.runningOutAngle, // was 'runningOut' — must match setWinkelkraft parameter keys
        etc: data.etcAngle
    }

    torques = actuatorService.setTorques(data.bto, data.running, data.eto, data.btc, data.runningOut, data.etc);
    winkelKraftObject = actuatorService.setWinkelkraft(torques, securityFactors, actuatorAngles);
    actuatorService.setKlappe();

    const controlType = data.controlType;
    const driveTypeA = data.driveTypeA;
    const driveType = data.driveType;
    const minBar = data.pressureMin;
    const maxBar = data.pressureMax;
    const MAST = data.mast;
    const tolerance = data.tolerance;
    const items = data.items;

    let busta: number[];

    if(MAST) {
        busta = [minBar, maxBar];
    } else {
        busta = [minBar, minBar+0.5];
    }

    for(let antrieb = 0; antrieb < asBasis.ANTRIEBE_ARRAY.length; antrieb++) {

        maxSum = actuatorService.setMaxNettoAntrieb(antrieb, tolerance, driveTypeA);

        let optiMIN = getTableValues(antrieb, controlType, driveTypeA, driveType, items, busta[0], busta[1], securityFactors, winkelKraftObject)

        if(optiMIN) {
            return {
                antrieb: optiMIN,
                found: true
            }
        }
    }

    return {
        antrieb: {},
        found: false,
        reason: 'no actuator found'
    }
};

const getTableValuesMAX = (antriebsIndex: number, zylIndex: number, federIndex: number, controlType: string, driveTypeA: string, driveType: string, items: number, maxBar: number, securityFactors: any) => {
    let winkelArray: number[];
    let khWinkelArray: number[];
    let knicklaengeArray: number[];
    let hebellaengeArray: number[];
    let knickwinkelGradArray: number[];
    let hebelwinkelGradArray: number[];
    let zylinderKraftArray: number[];
    let fResArray: number[];
    let mZylArray: number[];
    let fQuerArray: number[];
    let hubTotalArray: number[];

    let hub90ArrayHelper: number[];

    let newAntrieb: any = {};
    let zylKey;

    zylKey = asBasis.ZYLDURCHMESSER[controlType][antriebsIndex][zylIndex];
    let zylinderkraft: number;

    // EXCEL-SHEET "Berechnung"
    let kolben_kreisringflaeche: any;

    kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(controlType, asBasis.ZYLDURCHMESSER[controlType][antriebsIndex][zylIndex], items, antriebsIndex, asBasis.KOLBENSTANGE_DURCHMESSER_ARRAY);
    zylinderkraft = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kolbeGesamflaeche);

    let knickwinkel = (driveTypeA === 'AS-C') ? 12 : 0;
    HUB_ARRAY = (driveTypeA === 'AS-C') ? asBasis.HUB_ARRAY_CANTED : asBasis.HUB_ARRAY_SYM;

    const tableValues = actuatorService.getTable(antriebsIndex,knickwinkel,zylinderkraft, driveTypeA);

    winkelArray = tableValues.winkelArray;
    khWinkelArray = tableValues.khWinkelArray;
    knicklaengeArray = tableValues.knicklaengeArray;
    hebellaengeArray = tableValues.hebellaengeArray;
    knickwinkelGradArray = tableValues.knickwinkelGradArray;
    hebelwinkelGradArray = tableValues.hebelwinkelGradArray;
    zylinderKraftArray = tableValues.zylinderKraftArray;
    fResArray = tableValues.fResArray;
    mZylArray = tableValues.mZylArray;
    fQuerArray = tableValues.fQuerArray;
    hubTotalArray = tableValues.hubTotalArray;
    hub90ArrayHelper = tableValues.hub90ArrayHelper;

    newAntrieb[zylKey] = {
        khWinkelArray: khWinkelArray,
        winkelArray: winkelArray,
        knicklaengeArray: knicklaengeArray,
        hebellaengeArray: hebellaengeArray,
        knickwinkelGradArray: knickwinkelGradArray,
        hebelwinkelGradArray: hebelwinkelGradArray,
        zylinderKraftArray: zylinderKraftArray,
        fResArray: fResArray,
        mZylArray: mZylArray,
        fQuerArray: fQuerArray,
        hubTotalArray: hubTotalArray,
        hub90ArrayHelper: hub90ArrayHelper
    };

    let src, sro = {}

    /* SRC */

    let federkraftArray: number[] = [];
    let fRESFederzylinderArray: number[] = [];
    let mFEDFederzylinderArray: number[] = [];
    let fQuerFederzylinderArray: number[] = [];
    let mResZylArray: number[] = [];
    let klappeBTOETOArray: number[] = [];
    let klappeBTCETCArray: number[] = [];

    /* SRO */
    let federkraftSROarray: number[] = [];
    let fRESFederzylinderSROarray: number[] = [];
    let mFEDFederzylinderSROarray: number[] = [];
    let fQuerFederzylinderSROarray: number[] = [];
    let mResZylSROarray: number[] = [];
    let klappeSRO_BTOETOarray: number[] = [];
    let klappeSRO_BTCETCarray: number[] = [];

    let federKEY = '';

    // IST MAX DREHMOMENT ERREICHT?
    let isOverMaxAct = false;

    if(driveType === 'DA') {

        let klappeDA_BTOETOarray: number[];
        let klappeDA_BTCETCarray: number[];

        klappeDA_BTOETOarray = actuatorService.getKlappe().open;
        klappeDA_BTCETCarray = actuatorService.getKlappe().close;

        const zylKraftClose = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
        const tableValuesClose = actuatorService.getTable(antriebsIndex,knickwinkel,zylKraftClose, driveTypeA);

        const tableValuesOpen = tableValues;

        const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antriebsIndex, zylKey, 'forward', maxSum);
        console.log('chartDA', chartDA);
        if(chartDA.ismZylOK) {
            console.log('chartDA', chartDA);

            if(!chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {
                const label = ml(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, controlType, federKEY);
                logASLabelDecision({
                    phase: 'DA candidate accepted in getTableValuesMAX',
                    driveType,
                    driveTypeA,
                    controlType,
                    antriebIndex: antriebsIndex,
                    antriebValue: asBasis.ANTRIEBE_ARRAY[antriebsIndex],
                    zylKey,
                    federKEY,
                    label,
                    federOK: chartDA.ismZylOK,
                    isOverMaxAct: chartDA.isOverMaxAct,
                    cantedEndmomentLaufmomentOK: chartDA.cantedEndmomentLaufmomentOK,
                    torqueSnapshot: {
                        bto: tableValuesOpen.mZylArray[95],
                        run: tableValuesOpen.mZylArray[50],
                        eto: tableValuesOpen.mZylArray[5],
                        btc: tableValuesClose.mZylArray[5],
                        runOut: tableValuesClose.mZylArray[50],
                        etc: tableValuesClose.mZylArray[95]
                    }
                });

                return {
                    antriebDrehsObj: buildAntriebDrehsObj({
                        openArray: tableValuesOpen.mZylArray,
                        closeArray: tableValuesClose.mZylArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    }),
                    chart: {
                        klappeOPEN: klappeDA_BTOETOarray,
                        klappeCLOSE: klappeDA_BTCETCarray,
                        mZylArray: newAntrieb[zylKey].mZylArray,
                        driveType: driveType,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        drehWinkel: winkelKraftObject
                    },
                    label,
                    zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebsIndex], HUB_ARRAY[antriebsIndex])
                }
            }
        }

    } else {
        // C3, B3, ... A1
        federKEY = asBasis.federPaketeArray[antriebsIndex][federIndex];

        federkraftArray = [];
        fRESFederzylinderArray = [];
        mFEDFederzylinderArray = [];
        fQuerFederzylinderArray = [];
        mResZylArray = [];
        klappeBTOETOArray = [];
        klappeBTCETCArray = [];

        federkraftSROarray = [];
        fRESFederzylinderSROarray = [];
        mFEDFederzylinderSROarray = [];
        fQuerFederzylinderSROarray = [];
        mResZylSROarray = [];
        klappeSRO_BTOETOarray = [];
        klappeSRO_BTCETCarray = [];

        const myFederTables = actuatorService.getFederTable(antriebsIndex, federIndex, driveTypeA, hubTotalArray, hebelwinkelGradArray, hebellaengeArray, mZylArray, knickwinkel, federKEY);

        // SRC
        const mySRC = myFederTables.src;

        federkraftArray =  mySRC.federkraftArray;
        fRESFederzylinderArray =  mySRC.fRESFederzylinderArray;
        mFEDFederzylinderArray =  mySRC.mFEDFederzylinderArray;
        fQuerFederzylinderArray =  mySRC.fQuerFederzylinderArray;
        mResZylArray =  mySRC.mResZylArray;
        klappeBTOETOArray =  mySRC.klappeBTOETOArray;
        klappeBTCETCArray =  mySRC.klappeBTCETCArray;


        const mySRO = myFederTables.sro;

        federkraftSROarray = mySRO.federkraftSROarray;
        fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
        mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
        fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
        mResZylSROarray = mySRO.mResZylSROarray;
        klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
        klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;


        let federOK: boolean;
        let cantedEndmomentLaufmomentOK: boolean = false;

        let mahmut: any;

        // END IST MAX DREHMOMENT ERREICHT?

        if (driveType === 'SO') {

            const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxSum);
            federOK = chartSRO.federOK;
            isOverMaxAct = chartSRO.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;
            // mahmut = {
            //     'bto': mFEDFederzylinderSROarray[95],
            //     'run': mFEDFederzylinderSROarray[50],
            //     'eto': mFEDFederzylinderSROarray[5],
            //     'btc': mResZylSROarray[5],
            //     'runOut': mResZylSROarray[50],
            //     'etc': mResZylSROarray[95]
            // }

            mahmut = buildAntriebDrehsObj({
                openArray: mFEDFederzylinderSROarray,
                closeArray: mResZylSROarray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            sro = {
                federkraft: federkraftSROarray,
                fRES: fRESFederzylinderSROarray,
                mFED: mFEDFederzylinderSROarray,
                fQUER: fQuerFederzylinderSROarray,
                mResZYL: mResZylSROarray,
                klappeBTO_ETO: klappeSRO_BTOETOarray,
                klappeBTC_ETC: klappeSRO_BTCETCarray,

                federOK: chartSRO.federOK
            }
        }
        else {
            // SC
            const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxSum);
            federOK = chartSRC.federOK;
            isOverMaxAct = chartSRC.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

            // since SC, the values are upside down
            // mahmut = {
            //     'bto': mResZylArray[95],
            //     'run': mResZylArray[50],
            //     'eto': mResZylArray[5],
            //     'btc': mFEDFederzylinderArray[5],
            //     'runOut': mFEDFederzylinderArray[50],
            //     'etc': mFEDFederzylinderArray[95]
            // }

            mahmut = buildAntriebDrehsObj({
                openArray: mResZylArray,
                closeArray: mFEDFederzylinderArray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            src = {
                federkraft: federkraftArray,
                fRES: fRESFederzylinderArray,
                mFED: mFEDFederzylinderArray,
                fQUER: fQuerFederzylinderArray,
                mResZYL: mResZylArray,
                klappeBTO_ETO: klappeBTOETOArray,
                klappeBTC_ETC: klappeBTCETCArray,
                federOK: federOK
            }

        }

        if(federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {

            newAntrieb[zylKey][federKEY] = {
                src : src,
                sro : sro,
                maxDrehUberschritten: isOverMaxAct
            };

            let myLabel = ml(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, controlType, federKEY);

            logASLabelDecision({
                phase: 'SO/SC candidate accepted in getTableValuesMAX',
                driveType,
                driveTypeA,
                controlType,
                antriebIndex: antriebsIndex,
                antriebValue: asBasis.ANTRIEBE_ARRAY[antriebsIndex],
                zylKey,
                federKEY,
                label: myLabel,
                federOK,
                isOverMaxAct,
                cantedEndmomentLaufmomentOK,
                torqueSnapshot: mahmut
            });

            return {
                antriebDrehsObj: mahmut,
                label: myLabel,
                zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebsIndex], HUB_ARRAY[antriebsIndex]),
                chart: {
                    klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                    klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                    mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                    //mZylArray: (driveType === 'SO') ? mZylArray : mZylArray,
                    mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                    maxNettoDrehmoment: maxSum,
                    driveType: driveType,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    drehWinkel: winkelKraftObject
                }
            };
        }
    }

}

const getTableValues = (antrieb: number, controlType: string, driveTypeA: string, driveType: string, items: number, minBar: number, maxBar: number, securityFactors: any, winkelKraftObject: any) => {

    let winkelArray: number[] = [];

    let knicklaengeArray: number[] = [];
    let hebellaengeArray: number[] = [];
    let knickwinkelGradArray: number[] = [];
    let hebelwinkelGradArray: number[] = [];
    let zylinderKraftArray: number[] = [];
    let fResArray: number[] = [];
    let mZylArray: number[] = [];
    let fQuerArray: number[] = [];
    let hubTotalArray: number[] = [];

    let hub90ArrayHelper: number[] = [];

    let newAntrieb: any = {};
    let zylKey = 0;
    // 200 - 250 - 300 - 350...
    for (let zyl = 0; zyl < asBasis.ZYLDURCHMESSER[controlType][antrieb].length; zyl++) {
        zylKey = asBasis.ZYLDURCHMESSER[controlType][antrieb][zyl];

        winkelArray = [];
        khWinkelArray = [];
        knicklaengeArray = [];
        hebellaengeArray = [];
        knickwinkelGradArray = [];
        hebelwinkelGradArray = [];
        zylinderKraftArray = [];
        fResArray = [];
        mZylArray = [];
        fQuerArray = [];
        hubTotalArray = [];
        hub90ArrayHelper = [];

        let zylinderkraft = 0;
        // EXCEL-SHEET "Berechnung"
        let kolben_kreisringflaeche: any = {
            einfacherKolbenDurchmesser: 0,
            kolbeGesamflaeche: 0,
            kreisflaeche: 0,
            kreisring: 0,
            kreisringflaecheEinzeln: 0,
            kreisringflaecheGesamt: 0,
            kolbeFlaecheEinzeln: 0,
            kolbenstangeFlaecheEinzeln: 0
        };

        kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(controlType, asBasis.ZYLDURCHMESSER[controlType][antrieb][zyl], items, antrieb, asBasis.KOLBENSTANGE_DURCHMESSER_ARRAY);
        zylinderkraft = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kolbeGesamflaeche);

        let knickwinkel = (driveTypeA === 'AS-C') ? 12 : 0;
        HUB_ARRAY = (driveTypeA === 'AS-C') ? asBasis.HUB_ARRAY_CANTED : asBasis.HUB_ARRAY_SYM;


        const tableValues = actuatorService.getTable(antrieb,knickwinkel,zylinderkraft, driveTypeA);

        winkelArray = tableValues.winkelArray;
        khWinkelArray = tableValues.khWinkelArray;
        knicklaengeArray = tableValues.knicklaengeArray;
        hebellaengeArray = tableValues.hebellaengeArray;
        knickwinkelGradArray = tableValues.knickwinkelGradArray;
        hebelwinkelGradArray = tableValues.hebelwinkelGradArray;
        zylinderKraftArray = tableValues.zylinderKraftArray;
        fResArray = tableValues.fResArray;
        mZylArray = tableValues.mZylArray;
        fQuerArray = tableValues.fQuerArray;
        hubTotalArray = tableValues.hubTotalArray;
        hub90ArrayHelper = tableValues.hub90ArrayHelper;

        newAntrieb[zylKey] = {
            khWinkelArray: khWinkelArray,
            winkelArray: winkelArray,
            knicklaengeArray: knicklaengeArray,
            hebellaengeArray: hebellaengeArray,
            knickwinkelGradArray: knickwinkelGradArray,
            hebelwinkelGradArray: hebelwinkelGradArray,
            zylinderKraftArray: zylinderKraftArray,
            fResArray: fResArray,
            mZylArray: mZylArray,
            fQuerArray: fQuerArray,
            hubTotalArray: hubTotalArray,
            hub90ArrayHelper: hub90ArrayHelper
        };

        let src, sro = {}

        /* SRC */

        let federkraftArray: number[] = [];
        let fRESFederzylinderArray: number[] = [];
        let mFEDFederzylinderArray: number[] = [];
        let fQuerFederzylinderArray: number[] = [];
        let mResZylArray: number[] = [];
        let klappeBTOETOArray: number[] = [];
        let klappeBTCETCArray: number[] = [];

        /* SRO */
        let federkraftSROarray: number[] = [];
        let fRESFederzylinderSROarray: number[] = [];
        let mFEDFederzylinderSROarray: number[] = [];
        let fQuerFederzylinderSROarray: number[] = [];
        let mResZylSROarray: number[] = [];
        let klappeSRO_BTOETOarray: number[] = [];
        let klappeSRO_BTCETCarray: number[] = [];

        let federKEY = '';

        // IST MAX DREHMOMENT ERREICHT?
        let isOverMaxAct = false;

        if(driveType === 'DA') {

            let klappeDA_BTOETOarray: number[] = [];
            let klappeDA_BTCETCarray: number[] = [];

            klappeDA_BTOETOarray = actuatorService.getKlappe().open;
            klappeDA_BTCETCarray = actuatorService.getKlappe().close;

            const zylKraftClose = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
            const tableValuesClose = actuatorService.getTable(antrieb,knickwinkel,zylKraftClose, driveTypeA);

            const tableValuesOpen = tableValues;

            const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antrieb, zyl, 'forward', maxSum);

            if(chartDA.ismZylOK) {

                let drehmomentObj = buildAntriebDrehsObj({
                    openArray: tableValuesOpen.mZylArray,
                    closeArray: tableValuesClose.mZylArray,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    winkelKraftObject,
                    mode: 'forward'
                });

                if(!chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {

                    const optiMAX = getTableValuesMAX(antrieb, zyl, 0, controlType, driveTypeA, driveType, items, maxBar, securityFactors);

                    if(optiMAX) {

                        return {
                            mast: optiMAX,
                            antriebDrehsObj: drehmomentObj,
                            chart: {
                                klappeOPEN: klappeDA_BTOETOarray,
                                klappeCLOSE: klappeDA_BTCETCarray,
                                mZylArray: newAntrieb[zylKey].mZylArray,
                                mZylArrayClose: tableValuesClose.mZylArray,
                                maxNettoDrehmoment: maxSum,
                                driveType: driveType,
                                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                                drehWinkel: winkelKraftObject
                            },
                            label: ml(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antrieb], zylKey, controlType, federKEY),
                            zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antrieb], HUB_ARRAY[antrieb])
                        };
                    }


                }

            }
        } else {

            for (let paket = 0; paket < asBasis.federPaketeArray[antrieb].length; paket++) {

                // C3, B3, ... A1
                federKEY = asBasis.federPaketeArray[antrieb][paket];

                federkraftArray = [];
                fRESFederzylinderArray = [];
                mFEDFederzylinderArray = [];
                fQuerFederzylinderArray = [];
                mResZylArray = [];
                klappeBTOETOArray = [];
                klappeBTCETCArray = [];

                federkraftSROarray = [];
                fRESFederzylinderSROarray = [];
                mFEDFederzylinderSROarray = [];
                fQuerFederzylinderSROarray = [];
                mResZylSROarray = [];
                klappeSRO_BTOETOarray = [];
                klappeSRO_BTCETCarray = [];

                const myFederTables = actuatorService.getFederTable(antrieb, paket, driveTypeA, hubTotalArray, hebelwinkelGradArray, hebellaengeArray, mZylArray, knickwinkel, federKEY);

                // SRC
                const mySRC = myFederTables.src;

                federkraftArray =  mySRC.federkraftArray;
                fRESFederzylinderArray =  mySRC.fRESFederzylinderArray;
                mFEDFederzylinderArray =  mySRC.mFEDFederzylinderArray;
                fQuerFederzylinderArray =  mySRC.fQuerFederzylinderArray;
                mResZylArray =  mySRC.mResZylArray;
                klappeBTOETOArray =  mySRC.klappeBTOETOArray;
                klappeBTCETCArray =  mySRC.klappeBTCETCArray;


                const mySRO = myFederTables.sro;

                federkraftSROarray = mySRO.federkraftSROarray;
                fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
                mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
                fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
                mResZylSROarray = mySRO.mResZylSROarray;
                klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
                klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;


                let federOK: boolean = false;
                let cantedEndmomentLaufmomentOK: boolean = false;

                let mahmut: any = {};

                // END IST MAX DREHMOMENT ERREICHT?

                if (driveType === 'SO') {

                    const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxSum);
                    federOK = chartSRO.federOK;
                    isOverMaxAct = chartSRO.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;

                    // mahmut = {
                    //     'bto': mFEDFederzylinderSROarray[95],
                    //     'run': mFEDFederzylinderSROarray[50],
                    //     'eto': mFEDFederzylinderSROarray[5],
                    //     'btc': mResZylSROarray[5],
                    //     'runOut': mResZylSROarray[50],
                    //     'etc': mResZylSROarray[95]
                    // }

                    mahmut = buildAntriebDrehsObj({
                        openArray: mFEDFederzylinderSROarray,
                        closeArray: mResZylSROarray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    sro = {
                        federkraft: federkraftSROarray,
                        fRES: fRESFederzylinderSROarray,
                        mFED: mFEDFederzylinderSROarray,
                        fQUER: fQuerFederzylinderSROarray,
                        mResZYL: mResZylSROarray,
                        klappeBTO_ETO: klappeSRO_BTOETOarray,
                        klappeBTC_ETC: klappeSRO_BTCETCarray,
                        federOK: chartSRO.federOK
                    }
                }
                else {

                    // SC
                    const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxSum);

                    federOK = chartSRC.federOK;
                    isOverMaxAct = chartSRC.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

                    // since SC, the values are upside down
                    // mahmut = {
                    //     'bto': mResZylArray[95],
                    //     'run': mResZylArray[50],
                    //     'eto': mResZylArray[5],
                    //     'btc': mFEDFederzylinderArray[5],
                    //     'runOut': mFEDFederzylinderArray[50],
                    //     'etc': mFEDFederzylinderArray[95]
                    // }

                    mahmut = buildAntriebDrehsObj({
                        openArray: mResZylArray,
                        closeArray: mFEDFederzylinderArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    src = {
                        federkraft: federkraftArray,
                        fRES: fRESFederzylinderArray,
                        mFED: mFEDFederzylinderArray,
                        fQUER: fQuerFederzylinderArray,
                        mResZYL: mResZylArray,
                        klappeBTO_ETO: klappeBTOETOArray,
                        klappeBTC_ETC: klappeBTCETCArray,

                        federOK: federOK
                    }

                }

                if(federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {

                    newAntrieb[zylKey][federKEY] = {
                        src : src,
                        sro : sro,
                        maxDrehUberschritten: isOverMaxAct
                    };

                    let myLabel = ml(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antrieb], zylKey, controlType, federKEY);

                    const optiMAX = getTableValuesMAX(antrieb, zyl, paket, controlType, driveTypeA, driveType, items, maxBar, securityFactors);

                    if(optiMAX) {
                        console.log('mySRC', mySRC);
                        console.log('mySRO', mySRO);

                        return {
                            mast: optiMAX,
                            antriebDrehsObj: mahmut,
                            label: myLabel,
                            zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antrieb], HUB_ARRAY[antrieb]),
                            chart: {
                                klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                                klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                                mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                                mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                                maxNettoDrehmoment: maxSum,
                                driveType: driveType,
                                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                                drehWinkel: winkelKraftObject
                            }
                        };
                    }
                }
            }
        }
    }
};

/**
 * Returns label (Bezeichnung)
 * @param driveType
 * @param driveTypeA
 * @param antrieb
 * @param zylKey
 * @param controlType
 * @param federKEY
 */
function ml(driveType: string, driveTypeA: string, antrieb:string, zylKey:number, controlType: string, federKEY: string) {
    let driveTypeASHORT = (driveTypeA === 'AS-S')? 'S':'C'
    if(driveType === 'DA') {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType;
    } else {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType + '-' + federKEY;
    }

}

const actuatorASService = {
    getMasterAS
};

export default actuatorASService;

/*
if (antrieb === 1) {
    if(knickwinkel === 12) {
        if(federKEY === 'A3') {
            if(zylKey === 350) {
                if (driveType === 'SO') {

                }
            }
        }
    }
}
 */
